// extracted by mini-css-extract-plugin
export default {"component":"ShutdownButton_component__gdJn8","component_disabled":"ShutdownButton_component_disabled__-OMjC","icon":"ShutdownButton_icon__gg-31","text":"ShutdownButton_text__fyhX8"};